/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Seller_Notice_Tax_IdInputs */

const en_seller_notice_tax_id = /** @type {(inputs: Seller_Notice_Tax_IdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tax ID ${i?.id}`)
};

const pl_seller_notice_tax_id = /** @type {(inputs: Seller_Notice_Tax_IdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`NIP ${i?.id}`)
};

/**
* | output |
* | --- |
* | "Tax ID {id}" |
*
* @param {Seller_Notice_Tax_IdInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seller_notice_tax_id = /** @type {((inputs: Seller_Notice_Tax_IdInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Notice_Tax_IdInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seller_notice_tax_id(inputs)
	return en_seller_notice_tax_id(inputs)
});